import { ArchiveCancelOutlineIcon } from './ArchiveCancelOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 2D1FAE99-E9DD-480C-B144-8B7FC7AB99C4
 * name archive-cancel-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-cancel-outline.svg
 * tags
 */
export const BoxCancelOutlineIcon = ArchiveCancelOutlineIcon;
export default BoxCancelOutlineIcon